"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OctaviDashboardContribution = void 0;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const DashboardContribution_1 = require("chaire-lib-frontend/lib/services/dashboard/DashboardContribution");
//import BottomPanel from './OctaviBottomPanel';
const TransitionMenuBar_1 = __importDefault(require("transition-frontend/lib/components/dashboard/TransitionMenuBar"));
//import Toolbar from './OctaviToolbar';
//import FullSizePanel from './OctaviFullSizePanel';
const OctaviFullSizePanel_1 = __importDefault(require("octavi-legacy/lib/components/dashboard/OctaviFullSizePanel"));
const OctaviRightPanel_1 = __importDefault(require("octavi-legacy/lib/components/dashboard/OctaviRightPanel"));
/**
 * Dashboard contribution for the 'supply management' module of Transition: this
 * includes the agencies edition, GTFS import/export, routing and accessibility
 * map
 */
class OctaviDashboardContribution extends DashboardContribution_1.DashboardContribution {
    constructor() {
        super(...arguments);
        this.getLayoutContributions = () => [
            {
                id: 'transitionMenu',
                placement: 'menu',
                create: (props) => react_1.default.createElement(TransitionMenuBar_1.default, Object.assign({}, props))
            },
            /* {
                id: 'transitionToolbar',
                placement: 'toolbar' as const,
                create: (props: PanelSectionProps) => <Toolbar {...props}></Toolbar>
            },*/
            {
                id: 'transitionFSPanel',
                placement: 'mapOverlay',
                create: (props) => react_1.default.createElement(OctaviFullSizePanel_1.default, Object.assign({}, props))
            },
            {
                id: 'transitionRightPanel',
                placement: 'primarySidebar',
                create: (props) => react_1.default.createElement(OctaviRightPanel_1.default, Object.assign({}, props))
            }
        ];
    }
}
exports.OctaviDashboardContribution = OctaviDashboardContribution;
//# sourceMappingURL=OctaviDashboardContributions.js.map